import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  useTable,
  useGlobalFilter,
  usePagination,
} from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import { faEdit, faEllipsisV, faToggleOn, faTrashAlt, faPencil, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import moment from "moment";
const OperatorList = ({ permissions }) => {
  const [sewadars, setSewadars] = useState([]);
  const [search, setSearch] = useState("");
  const role = localStorage.getItem('role');
  const code = localStorage.getItem("code");
  const email = localStorage.getItem("email");
  const navigate = useNavigate(); // inside your component


  const handleEdit = (rowData) => {
    navigate("../operator", { state: { rowData } });
  };
  const fetchSewadars = async () => {
    const res = await apiClient.get(`${SERVER_BASE}/getOperators/${code}`);
    setSewadars(res.data);
  };

  useEffect(() => {
    fetchSewadars();
  }, [code]);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to delete this record?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      await apiClient.delete(`${SERVER_BASE}/deleteOperator/${id}`);
      fetchSewadars();
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Record deleted successfully.',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  const handleToggleStatus = async (id, Active) => {
    await apiClient.put(`${SERVER_BASE}/updateOperatorStatus/status/${id}`, { Active });
    fetchSewadars();

    Swal.fire({
      icon: 'success',
      title: `Status updated to ${Active}`,
      toast: true,
      position: 'top-end',
      timer: 3000,
      showConfirmButton: false,
    });
  };


  const columns = React.useMemo(
    () => [
      {
        Header: 'S.No',
        Cell: ({ row }) => row.index + 1,
      },
      { Header: "Badge ID", accessor: "badgeId" },
      { Header: "Name", accessor: "fullName" },
      { Header: "Mobile", accessor: "mobileNo" },
      { Header: "Department", accessor: "department" },
      // { Header: "Alt Mobile", accessor: "alternateMobileNo" },
      {
        Header: "Status",
        accessor: "Active",
        Cell: ({ value }) => (
          <span className={`badge bg-${value == "1" ? "success" : "secondary"}`}>
            {value == '1' ? 'Active' : 'Inactive'}
          </span>
        ),
      },
      {
        Header: "#",
        accessor: "Action",
        Cell: ({ row }) => {
          const {
            createdAt,
            createdByName,
            updatedAt,
            updatedByName,
          } = row.original;
          const id = row.original.id;
          const Active = row.original.Active;
          return (
            <div className="dropdown">
              <button
                className="btn btn-sm btn-light"
                type="button"
                id={`dropdownMenuButton-${row.index}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </button>

              <ul
                className="dropdown-menu"
                aria-labelledby={`dropdownMenuButton-${row.index}`}
              >
                {(permissions?.edit || role == 'itManager') && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      onClick={() => {
                        handleEdit(row.original);
                      }}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      Edit
                    </button>
                  </li>
                )}

                {(permissions?.edit || role == 'itManager') && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      onClick={() => {
                        handleToggleStatus(id, Active == 1 ? 0 : 1);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faToggleOn}
                        className={`me-2`}
                      />
                      Mark {Active == 1 ? "Inactive" : "Active"}
                    </button>
                  </li>
                )}

                {/* Optional delete if enabled */}
                {(permissions?.delete || role == 'itManager') && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      onClick={() => {
                        handleDelete(id);
                      }}
                    >
                      <FontAwesomeIcon icon={faTrashAlt} className="me-2" />
                      Delete
                    </button>
                  </li>
                )}
                {(createdByName || updatedByName) && (
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                )}
                {createdByName && (
                  <li className="dropdown-item">
                    <FontAwesomeIcon icon={faPlus} /> {createdByName}
                    {createdAt &&
                      ` (${moment(createdAt).format("DD-MMM-YY hh:mm A")})`}
                  </li>
                )}

                {/* Updated Info */}
                {updatedByName && (
                  <li className="dropdown-item">
                    <FontAwesomeIcon icon={faPencil} /> {updatedByName}
                    {updatedAt &&
                      ` (${moment(updatedAt).format("DD-MMM-YY hh:mm A")})`}
                  </li>
                )}
              </ul>
            </div>
          );
        },
      }


    ],
    [permissions]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    state,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    previousPage,
    nextPage,
    setPageSize,
  } = useTable(
    {
      columns,
      data: sewadars,
      initialState: { pageIndex: 0, pageSize: 25 },
    },
    useGlobalFilter,
    usePagination
  );

  const { pageIndex, pageSize } = state;

  return (
    <div className="formcontainer mt-5">
      <h4>Operator List</h4>

      <div className="mb-2 d-flex justify-content-between">
        {permissions?.write && (
          <button
            className="btn btn-outline-success"
            onClick={() => { navigate('../operator') }}
          >
            Add Operator
          </button>
        )}
        {permissions?.read && (
          <>
            <input
              className="form-control w-75"
              placeholder="Search..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setGlobalFilter(e.target.value || undefined);
              }}
            />
            <select
              className="form-select w-auto"
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[25, 50, 100].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </>
        )}
      </div>
      {(permissions?.read) && (
        <>
          <div className='table-responsive'>
            <table className="table table-bordered table-hover" {...getTableProps()}>
              <thead>
                {headerGroups.map((group) => (
                  <tr {...group.getHeaderGroupProps()} key={group.id}>
                    {group.headers.map((col) => (
                      <th {...col.getHeaderProps()} key={col.id}>
                        {col.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={row.id}>
                      {row.cells.map((cell) => (
                        <td {...cell.getCellProps()} key={cell.column.id}>
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex align-items-center mb-3">
            {/* Previous – left corner */}
            <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className="btn btn-secondary me-auto"
              style={{ minWidth: 110 }}   // keeps width consistent
            >
              Previous
            </button>

            {/* Center block for page index & size selector */}
            <div className="text-center flex-grow-1 d-flex flex-column align-items-center">
              {/* Row 1: Page index and size selector in one line */}
              <div className="d-flex align-items-center gap-3">
                <div className="fw-semibold">
                  Page {pageIndex + 1} of {pageOptions.length}
                </div>


              </div>
            </div>


            {/* Next – right corner */}
            <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className="btn btn-secondary ms-auto"
              style={{ minWidth: 110 }}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default OperatorList;
